import React from 'react';
import { useRecoilValue } from 'recoil';
import { CardBody } from '../../components/CardBody';
import { CardHeader } from '../../components/CardHeader';
import { CardTitle } from '../../components/CardTitle';

import { allProductsState } from '../../recoil/atoms';
import { assetPathFn } from '../../util';
import { ShopNowCardFooter, ShopNowCardSection } from '../HomeLander/HomeLanderMobile';
import { HeroCallout } from '../HeroCallout';
import { WistiaPanel } from '../../components/WistiaPanel';
import { NewsIcons } from '../../product_detail/components/NewsIcons';
import { ShopAllColors } from '../components/ShopAllColors';
import { ProductFeatures } from '../components/ProductFeatures';
import { LanderTopHero } from '../components/LanderTopHero';
import { ProductHandle } from '../../enums/ProductHandle.enum';
import styles from './VNeckBraLanderMobile.module.scss';
import { CardFooter } from '../../components/CardFooter';
import { useLanderControls } from '../LanderContext';

export const VNeckBraLanderMobile: React.FC = () => {
  const allProducts = useRecoilValue(allProductsState);
  const { scrollToProductSection } = useLanderControls();

  const wistiaVideoId = 'txjj1yry1r';
  const padding = { padding: '145.0% 0 0 0' };

  return (
    <>
      <CardBody>
        <LanderTopHero heroImage={'mobile-vnb-lander-top-hero-1.jpg'} title={'V-Neck Bra'} subTitle={'So comfortable you’ll forget you’re wearing a bra.'}>
          <HeroCallout
            orderIndex={0}
            label={
              <>
                Comfortable
                <br /> straps
              </>
            }
            titleStyles={{ lineHeight: '20px' }}
            inlineStyles={{
              mobile: {
                right: `34%`,
                top: `20%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
          <HeroCallout
            orderIndex={1}
            label={'Soft removable cups'}
            inlineStyles={{
              mobile: {
                right: `31%`,
                top: `40%`,
                flexDirection: 'row',
              },
            }}
          />
          <HeroCallout
            orderIndex={2}
            label="Wire-free lift"
            inlineStyles={{
              mobile: {
                right: `7%`,
                top: `51%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
        </LanderTopHero>
      </CardBody>
      <ShopNowCardFooter onClick={scrollToProductSection} />
      <CardHeader />
      <CardBody>
        <NewsIcons />
        <ProductFeatures
          features={[
            {
              imgName: 'feature-vneck-bra-desktop-1.jpg',
              title: 'Underwire-free lift',
              description: 'Bonding at the cradle lifts your chest for a supportive, comfortable lift.',
            },
            {
              imgName: 'feature-vneck-bra-desktop-2.jpg',
              title: 'Invisible seams ',
              description: 'Bonded seams lay flat against skin and disappear completely under clothes.',
            },
            {
              imgName: 'feature-vneck-bra-desktop-3.jpg',
              title: 'Totally smooth',
              description: 'Compressive stretch fabric and a flattering cut prevent bumps and bulges.',
            },
          ]}
        />
        <CardTitle text="Innovation you can see" style={{ paddingTop: 0 }} />
        <div className={styles.comparison}>
          <img src={assetPathFn('vneck-bra-before-after.jpg')} alt="comparison" />
          <div>
            <div>competitor</div>
            <div>
              superpower <br />
              short
            </div>
          </div>
        </div>
        <ShopNowCardSection onClick={scrollToProductSection} />
        <WistiaPanel videoId={wistiaVideoId} responsivePadding={padding} />
        <ShopAllColors product={allProducts[ProductHandle.VNeckBra]} />
      </CardBody>
      <CardFooter />
    </>
  );
};

export default VNeckBraLanderMobile;
